import React from "react";
import styles from "./DomainSearchForm.scss";
import {getInitialMeta} from "@helpers/HelperInitialPageState";
import {useTLDContext} from "@contexts/ContextTLDProvider";
import {useTyped} from "@hooks/useTyped";
import messages from "@lang/messages";
import {BeforeSubmitDomainsSearch} from "@helpers/HelperFunc";
import Default from "./layouts/Default";
import BottomMenu from "./layouts/BottomMenu";
import {notify} from "@contexts/ContextNotificationProvider";

const DomainSearchForm = ({
							  data,
							  layout = 'Default',
							  buttonLayout = 'default',
							  showAllLink = false,
							  fromPage = '',
							  color = ''
						  }) => {

	if (!data) {
		return null;
	}

	const tldContext = useTLDContext();

	const {inputRef} = useTyped(
	  data.animationTexts ?? [],
	  {
		  typeSpeed: 70,
		  backSpeed: 110,
		  backDelay: 800
	  },
	  {
		  staticPlaceholderOnFocus: data.placeHolder ?? "",
	  }
	);

	const onSubmitForm = (e) => {
		e.preventDefault();
		let domainNameFull = (inputRef.current?.value || '').trim();

		BeforeSubmitDomainsSearch(domainNameFull, fromPage);

		tldContext.submitSearchDomainForm(
		  e,
		  domainNameFull,
		  // callBackSuccess
		  () => {
			  // Some success logic here...
		  },
		  // callBackError
		  (error) => {
			  if (messages[getInitialMeta('pageLang')][error]) {
				  notify.alert(messages[getInitialMeta('pageLang')][error].replace('{%domainName%}', domainNameFull));
			  } else {
				  notify.alert('Unknown error occurred.');
			  }
			  return false;
		  }
		);
	};

	const layouts = {
		Default, BottomMenu
	};
	const LayoutComponent = layouts[layout] ?? Default;

	return (
	  <LayoutComponent
		data={data}
		buttonLayout={buttonLayout}
		onSubmitForm={onSubmitForm}
		inputRef={inputRef}
		showAllLink={showAllLink}
		color={color}
	  />
	);
}

export default DomainSearchForm;